import React from 'react';
import { SignUp as ClerkSignUp } from '@clerk/clerk-react';
import styled from 'styled-components';

const SignUpContainer = styled.div`
  display: flex;
  
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: ${({ theme }) => theme.bg};
`;

const SignUpCard = styled.div`
  background: ${({ theme }) => theme.card};
  border-radius: 12px;
  padding: 1rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid ${({ theme }) => theme.soft};
`;

const Title = styled.h1`
  text-align: center;
  margin-bottom: 1rem;
  color: ${({ theme }) => theme.text_primary};
  font-size: 2rem;
  font-weight: 600;
`;

const SignUp = () => {
  return (
    <SignUpContainer>
      <SignUpCard>
        <Title>Welcome</Title>
        <ClerkSignUp 
          appearance={{
            elements: {
              rootBox: {
                width: '100%',
              },
              card: {
                backgroundColor: 'transparent',
                boxShadow: 'none',
                height: '1000%',
                border: 'none',
              },
              headerTitle: {
                color: '#ffffff',
                fontSize: '1.5rem',
              },
              headerSubtitle: {
                color: '#a0a0a0',
              },
              socialButtonsBlockButton: {
                backgroundColor: '#2a2a2a',
                border: '1px solid #404040',
                height: '40px',
                color: '#ffffff',
                '&:hover': {
                  backgroundColor: '#3a3a3a',
                },
              },
              formFieldInput: {
                backgroundColor: '#ffffff',
                border: '1px solid #404040',
                height: '40px',
                color: '#404040',
                '&:focus': {
                  borderColor: '#6366f1',
                },
              },
              formButtonPrimary: {
                backgroundColor: '#6366f1',
                height: '50px',
                '&:hover': {
                  backgroundColor: '#5855eb',
                },
              },
              footerActionLink: {
                color: '#6366f1',
              },
              identityPreviewText: {
                color: '#ffffff',
              },
              identityPreviewEditButton: {
                color: '#6366f1',
              },
              footer: {
                display: 'none', // Hide the "Secured by Clerk" footer
              },
              footerText: {
                display: 'none',
              },
              footerAction: {
                display: 'none',
              },
            },
          }}
        />
      </SignUpCard>
    </SignUpContainer>
  );
};

export default SignUp;
